'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BaseClass2 = require('./BaseClass');

var _BaseClass3 = _interopRequireDefault(_BaseClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sibling = function (_BaseClass) {
  _inherits(Sibling, _BaseClass);

  /**
   * Nachname
   * @type {string}
   */

  /**
   * Vorname
   * @type {string}
   */

  /**
   * Geburtsdatum
   * @type {date}
   */

  /**
   * Kundennummer
   * @type {string}
   */
  function Sibling() {
    _classCallCheck(this, Sibling);

    var _this = _possibleConstructorReturn(this, (Sibling.__proto__ || Object.getPrototypeOf(Sibling)).call(this));

    _this.Name1 = '';
    _this.Name2 = '';
    _this.DateOfBirth = '';
    _this.CustomerNumber = '';
    _this.Info = '';
    return _this;
  }

  /**
   * Name der Schule
   * @type {string}
   */


  return Sibling;
}(_BaseClass3.default);

exports.default = Sibling;